// extracted by mini-css-extract-plugin
module.exports = {"modal":"vi","error":"wi","disabled":"xi","fields":"yi","header":"zi","footer":"Ai"};